import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function advancedQueryFunc(data) {
  return request({
    url: URL.booking.cabinManagement.advancedQueryUrl,
    method: 'post',
    data
  })
}

export function loadCabinManagementFunc(params) {
  return request({
    url: URL.booking.cabinManagement.loadCabinManagementUrl,
    method: 'get',
    params: params
  })
}

export function checkDuplicateFunc(data) {
  return request({
    url: URL.booking.cabinManagement.checkDuplicateUrl,
    method: 'post',
    data
  })
}

/**
 * 根据job业务uuid 复制一个舱位
 * @param data
 * @returns {*}
 */
export function copySaveByJobFunc(data) {
  return request({
    url: URL.booking.cabinManagement.copySaveByJobUrl,
    method: 'post',
    data
  })
}

/**
 * 复制舱位信息
 * @param data
 * @returns {*}
 */
export function doCopyCabinFunc(data) {
  return request({
    url: URL.booking.cabinManagement.doCopyCabinUrl,
    method: 'post',
    data
  })
}

/**
 * 保存舱位信息
 * @param data
 * @returns {*}
 */
export function saveFunc(data) {
  return request({
    url: URL.booking.cabinManagement.saveUrl,
    method: 'post',
    data
  })
}

/**
 * 更新舱位信息
 * @param data
 * @returns {*}
 */
export function cabinUpdateFunc(data) {
  return request({
    url: URL.booking.cabinManagement.cabinUpdateUrl,
    method: 'post',
    data
  })
}

/**
 * 批量转船批量更新舱位信息
 * @param data
 * @returns {*}
 */
export function batchUpdateCabin(data) {
  return request({
    url: URL.booking.cabinManagement.batchUpdateCabin,
    method: 'post',
    data
  })
}

/**
 * 舱单分配
 * @param data
 * @returns {*}
 */
export function allocationFunc(data) {
  return request({
    url: URL.booking.cabinManagement.allocationUrl,
    method: 'post',
    data
  })
}
/**
 * 校验舱单是否可以取消关联
 * @param data
 * @returns {*}
 */
export function checkJobCancelCabinFunc(data) {
  return request({
    url: URL.booking.cabinManagement.checkJobCancelCabinUrl,
    method: 'post',
    data
  })
}

export function batchDeleteCabinManagement(data) {
  return request({
    url: URL.booking.cabinManagement.batchDeleteCabinManagement,
    method: 'post',
    data
  })
}

/**
 * 保存复制的舱位
 * @param data
 * @returns {*}
 */
export function saveCopyCabinFunc(data) {
  return request({
    url: URL.booking.cabinManagement.saveCopyCabinUrl,
    method: 'post',
    data
  })
}

